<template>
  <div class="container py-5">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="mb-0">Java темы</h1>
      <div class="d-flex gap-2">
        <button id="theme-toggle" class="btn btn-secondary">Тёмная тема</button>
        <button class="btn btn-primary" @click="showTopics = !showTopics">
          {{ showTopics ? 'Скрыть' : 'Показать' }}
        </button>
      </div>
    </div>

    <ul class="list-group" v-show="showTopics">
      <li class="list-group-item d-flex justify-content-between align-items-center" v-for="topic in topics" :key="topic">
        <span>{{ topic }}</span>
        <div class="btn-group">
          <a class="btn btn-outline-secondary btn-sm" :href="`topic.html?file=${topic}`">Q</a>
          <a class="btn btn-outline-secondary btn-sm" :href="`quiz.html?file=${topic}`">Q/A</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      topics: [],
      showTopics: true
    };
  },
  mounted() {
    fetch('topics.json')
      .then(r => r.json())
      .then(data => {
        this.topics = data;
      });
  }
};
</script>

